export const Bio = {
  name: "Muhammed Sahad",
  roles: ["MERN Stack Developer", "Programmer"],
  description:
    "I'm a passionate developer focused on building scalable applications.",
  github: "https://github.com/Muhammed-Sahad-P",
  resume: "/MUHAMMED-SAHAD-P-Mern.pdf",
  linkedin: "https://www.linkedin.com/in/muhammed-sahad-p/",
};

export const skills = [
  {
    skills: [
      {
        name: "HTML",
        image: "html5-logo.png",
      },
      {
        name: "CSS",
        image: "CSS3-logo.png",
      },
      {
        name: "JavaScript",
        image: "JavaScript-logo.png",
      },

      {
        name: "MongoDB",
        image: "mongodb.svg",
      },
      {
        name: "Express Js",
        image: "express-js.png",
      },
      {
        name: "React Js",
        image: "react.webp",
      },
      {
        name: "Node Js",
        image: "node.png",
      },
      {
        name: "Redux",
        image: "redux.svg",
      },
      {
        name: "Next Js",
        image: "nextjs.png",
      },
      {
        name: "TypeScript",
        image: "typeScript.png",
      },
      {
        name: "Axios",
        image: "axios.png",
      },
      {
        name: "Bootstrap",
        image: "bootstrap-logo.png",
      },
      {
        name: "Tailwind",
        image: "tailwind.svg",
      },
      {
        name: "Git",
        image: "Git-Icon.png",
      },
      {
        name: "GitHub",
        image: "Github.png",
      },
      {
        name: "VS Code",
        image: "vscode-logo.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/D560BAQFAHz72JL7UDw/company-logo_200_200/company-logo_200_200/0/1710409918291/bridgeon_solutions_logo?e=2147483647&v=beta&t=vdRzQuYc_gfZyi3NzmVUvgoDixFK5yi_XnYq2JPROFo",
    role: "MERN Stack Developer Intern",
    company: "Bridgeon Solutions LLP",
    date: "May 2024 - Present",
    desc: "I am currently working as a MERN Stack Developer Intern at Bridgeon Solutions LLP.",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "Git",
      "GitHub",
      "MongoDB",
      "ExpressJS",
      "ReactJS",
      "Node Js",
      "TypeScript",
      " Next Js",
      "Bootstrap",
      "Tailwind CSS",
      "Cloudinary",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "UOC.png",
    school: "Calicut University",
    date: "2021 - 2024",
    grade: "5.782 CGPA",
    desc: "I have recently completed a Bachelor's degree in Information Technology at HM College Of Science and Technology, Manjeri.",
    degree: "Bachelor of Science - Information Technology",
  },
];

export const projects = [
  {
    id: 9,
    title: "FootFusion",
    descriptionPoints: [
      "Foot Fusion is a dynamic e-commerce platform designed to provide users with a seamless shopping experience for shoes.",
      "Integrated Razorpay for secure online payments.",
      "Features include cart and wishlist functionality to enhance user experience.",
      "Implements pagination for easy browsing of products.",
      "Includes skeleton spinner for improved loading experience.",
      "The website aims to cater to a diverse range of customers by offering a wide selection of footwear, including athletic shoes, casual wear, and formal options.",
      "Built using the MERN stack, Foot Fusion integrates modern web technologies to ensure responsiveness and user-friendliness.",
      "Deployed on Vercel and Render for fast and reliable hosting",
    ],
    shortDesc:
      "A dynamic e-commerce platform designed to provide users with a seamless shopping experience for shoes.",
    image: "FootFusion.png",
    tags: [
      "MongoDB",
      "ExpressJS",
      "ReactJS",
      "NodeJS",
      "TailwindCSS",
      "Razorpay",
      "Vercel",
      "Render",
    ],
    category: "web app",
    github: "https://github.com/Muhammed-Sahad-P/footfusion-frontend",
    webapp: "https://footfusion.vercel.app/",
  },

  {
    id: 10,
    title: "DOQUE",
    descriptionPoints: [
      "DOQUE is a task management app designed to boost team productivity and streamline workflows.",
      "Features include customizable workspaces with drag-and-drop task management, real-time chat, and member management.",
      "A user-friendly dashboard tracks project progress, and email OTP verification ensures secure onboarding.",
      "Dark mode enhances usability in low-light environments, while Cloudinary integration supports efficient media uploads.",
      "Payment workflows are powered by Stripe, and the backend features robust error handling, JWT authentication, and secure APIs.",
      "Technologies: Next.js, TypeScript, Tailwind CSS, Node.js, Express.js, MongoDB, Vercel, Cloudinary, Stripe, Nodemailer.",
    ],
    shortDesc:
      "A cutting-edge task management application designed to enhance team productivity and streamline project workflows.",
    image: "DOQUE.png",
    tags: [
      "NextJS",
      "TypeScript",
      "TailwindCSS",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "Cloudinary",
      "Figma",
      "Vercel",
    ],
    category: "web app",
    github: "https://github.com/Muhammed-Sahad-P/project-doque",
    webapp: "https://doque.vercel.app",
  },

  {
    id: 11,
    title: "Pinterest-Clone",
    descriptionPoints: [
      "Pinterest Clone is a visually appealing platform where users can explore, create, and organize pins into customizable boards.",
      "Key features include user authentication, pin creation, saving, liking, commenting.",
      " Users can like pins to increase their like count, contributing to user engagement metrics.",
      " Built with a modern stack including Next.js, TypeScript, Redux, Node.js, and MongoDB, the application delivers efficient performance and scalability.",
      " Styled with Tailwind CSS, it offers an intuitive and user-friendly interface, making idea-sharing seamless and enjoyable.",
    ],
    shortDesc:
      "A responsive web application that replicates the popular social media platform, Pinterest.",
    image: "pinterest.png",
    tags: [
      "NextJS",
      "TypeScript",
      "MongoDB",
      "ExpressJS",
      "NodeJS",
      "TailwindCSS",
      "Vercel",
      "Render",
    ],
    category: "web app",
    github: "https://github.com/Muhammed-Sahad-P/Pinterest-Clone",
    webapp: "https://pinterest-clone-sahad.vercel.app",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
